module.exports = __webpack_public_path__ + "img/camera-retro.f50bf961.svg";